import { ReduxAction } from 'types/redux';
import { PROFILE_BILLING } from "../../constants/profile-billing.constants";

const initialState = {
  loading: false,
  data: {},
  error: '',
};

export function profileBilling(state = initialState, action: ReduxAction) {
  switch (action.type) {
    case PROFILE_BILLING.REQUEST:
      return {
        ...state,
        loading: true,
        data: {},
        error: '',
      };
    case PROFILE_BILLING.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.profileBilling,
        error: '',
      };
    case PROFILE_BILLING.FAILURE:
      return {
        ...state,
        loading: false,
        data: {},
        error: action.error,
      };
    default:
      return state;
  }
}
